import { render, staticRenderFns } from "./WhatIsUpside.vue?vue&type=template&id=279a18cc&scoped=true&"
import script from "./WhatIsUpside.vue?vue&type=script&lang=js&"
export * from "./WhatIsUpside.vue?vue&type=script&lang=js&"
import style0 from "./WhatIsUpside.vue?vue&type=style&index=0&id=279a18cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279a18cc",
  null
  
)

export default component.exports